/**
 * Constants containing titles for modules/pages in the app.
 */
export const PAGE_TITLES = {
  DASHBOARD: 'Dashboard',
  CUSTOMER: 'Khách hàng',
  COMPANY: 'Công ty',
  ORDERS: 'Đơn hàng',
  COMING_SOON: 'Sắp ra mắt',
  PROFILE: 'Hồ Sơ',
  SETTINGS: 'Cài đặt',
  BILLING: 'Hóa đơn',
  COUPON: 'Mã giảm giá',
  CATALOG: 'Catalog',
  FORM_FIELDS: 'Form fields',
  NOTIFICATIONS: 'Thông báo',
  AUDIT: 'Nhật ký hoạt động',
  PAYMENTSETTINGS: 'Cổng thanh toán',

  LOGIN: 'Đăng nhập',
  REGISTER: 'Đăng ký',
  FORGOT_PASSWORD: 'Quên mật khẩu',
  RESET_PASSWORD: 'Đặt lại mật khẩu',
  VERIFY_CODE: 'Mã xác minh',

  NOT_FOUND: 'Không tìm thấy',
  UNAUTHORIZED: 'Không có quyền truy cập',
  SERVER_ERROR: 'Lỗi máy chủ',
} as const;

export type PageTitleKey = keyof typeof PAGE_TITLES;
